import * as React from 'react';

const LeadIcon = ({fillColor = '#2D2756'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={19} height={16}>
    <path
      fill={fillColor}
      d="M3.79 15.75c-.125.097-.247.1-.365.01-.118-.09-.156-.211-.114-.364L4.957 10 .623 6.896C.498 6.813.46 6.698.51 6.552c.048-.146.149-.219.302-.219h5.354L7.873.667A.42.42 0 0 1 7.988.5a.263.263 0 0 1 .177-.063c.07 0 .128.021.177.063a.42.42 0 0 1 .115.167l1.708 5.666h5.354c.153 0 .254.073.302.22.049.145.01.26-.114.343L11.373 10l1.646 5.396c.042.153.004.274-.114.364-.118.09-.24.087-.365-.01l-4.375-3.333L3.79 15.75Zm1.52-2.813 2.855-2.166 2.854 2.166-1.146-3.604 2.625-1.708H9.352L8.165 4.021 6.977 7.625H3.832l2.625 1.708-1.146 3.604Zm10.272 2.792L14.644 15l-1.333-4.333 3.208-2.292h1.167c.153 0 .253.073.302.219.049.146.01.26-.115.344l-3.104 2.229 1.313 4.229c.041.153 0 .27-.125.354-.125.083-.25.076-.375-.02ZM11.415 4.667l-.625-2.125.562-1.875A.42.42 0 0 1 11.467.5a.263.263 0 0 1 .177-.063c.07 0 .132.021.188.063a.379.379 0 0 1 .125.167l1.208 4h-1.75Z"
    />
  </svg>
);

export default LeadIcon;
